export default __webpack_public_path__ + "static/michalg-d6e48bf3d67ae1237dcc4f5b8ac7bf5b.jpg";